"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _SearchPeople = _interopRequireDefault(require("@rsuite/icon-font/lib/people/SearchPeople"));

// Generated by script, don't edit it please.
var SearchPeople = (0, _createSvgIcon["default"])({
  as: _SearchPeople["default"],
  ariaLabel: 'search people',
  category: 'people',
  displayName: 'SearchPeople'
});
var _default = SearchPeople;
exports["default"] = _default;
module.exports = exports.default;